module.exports = __webpack_public_path__ + "static/mo32-9f3bc31287591e2e384e5c079ad2c645.png";